import React, {useMemo,useEffect,useState} from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { PaymentStatus,OrderdStatus } from "../../Dashboard/LatestTranactionCol";
import withRouter from "../../../components/Common/withRouter";
import {
    Badge,
    Card,
    CardBody,
    Button,
    CardText,
    Col,
    Container,
    Row,
    Table,
    Nav,
    NavItem,
    NavLink,
    TabPane,
    TabContent,
    Input,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
}

from "reactstrap";
import {
    useNavigate,
    useParams
}

from "react-router-dom";
import toast from "react-hot-toast";
import {
    Link
}

from "react-router-dom";
import ManageInvoice from "./ManageInvoice";
import ManageOutward from "./ManageOutward";
import { formatDateTime } from "../../../utils/dayjs";
import TableContainer from "../../../components/Common/TableContainer";
const ViewIndividualOrder=()=> {
    const baseurl=process.env.REACT_APP_BASE_URL;
    const imgurl=process.env.REACT_APP_IMAGE_URL;
    const user=JSON.parse(localStorage.getItem("authUser"));
    const [orderData,setOrderData]=useState(null);
    const [loading,setLoading]=useState(true);
    const [activeTab,setActiveTab]=useState( localStorage.getItem("activeTab") || "1");
    const [invoiceData,setInvoiceData]=useState([]);
    const [selectedItem,setSelectedItem]=useState(null);
    const [outwardModal,setOutwardModal]=useState(false);
    const [outwardQty,setOutwardQty]=useState("");

    const [isOpen, setIsOpen] = useState(false);
const [notes, setNotes] = useState();
    
    const [outwardItems,setOutwardItems]=useState([]);
    const {id}=useParams();
    const navigate=useNavigate();
    useEffect(()=> {
        const fetchOrder=async ()=> {
            try {
                const response=await fetch(`${baseurl}/admin/customer/order-detail/${id}`);
                if ( !response.ok) throw new Error("Network response was not ok");
                const data=await response.json();
                setOrderData(data.data);

                 // Mark cart as viewed
      await fetch(
        `${baseurl}/admin/customer/individuals/orders/${id}/viewed`,
        {
          method: "PUT",
        }
      );
            }
            catch (error) {
                console.error("Failed to fetch order", error);
            }
            finally {
                setLoading(false);
            }
        };
        fetchOrder();
        
        fetchInvoiceDetails()
    }
    , [id]);
    
    
    
    ;
    const fetchInvoiceDetails=async ()=> {
        try {
            const res=await fetch(`${baseurl}/admin/customer/invoiceslist/${id}`);
            const data=await res.json();
            setInvoiceData(data);
        }
        catch (err) {
            console.error(err);
        }
    }
    ;

    const handleSave = async () => {
  try {
    const res = await fetch(
      baseurl + `/admin/customer/update-notes/${orderData.order.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          notes: notes,
        }),
      }
    );

    const data = await res.json(); // ✅ important

    if (data.success) {
      // ✅ better state update
      setOrderData((prev) => ({
        ...prev,
        order: {
          ...prev.order,
          notes,
        },
      }));
toast.success('Notes updated successfully!', 'success');
      setIsOpen(false);
    }
  } catch (err) {
    console.error(err);
  }
};
    
      
    document.title="Order details | Vekart";
    if (loading) return <p className="text-center">Loading...</p>;
    if ( !orderData) return <p className="text-center">Order not found</p>;
    const isIntraState=orderData.billingAddress.state?.toLowerCase()==="gujarat";
    const subtotal =
  orderData?.items?.reduce((total, product) => {
    const price = Number(product.price) || 0;
    const qty = Number(product.quantity) || 0;
    const discount = Number(product.discount) || 0;

    const discountedPrice = price - (price * discount) / 100;
    const taxableValue = discountedPrice * qty;

    let rowTotal = taxableValue;

    if (isIntraState) {
      const cgstRate = Number(product.cgst) || 0;
      const sgstRate = Number(product.sgst) || 0;

      const cgstAmount = taxableValue * (cgstRate / 100);
      const sgstAmount = taxableValue * (sgstRate / 100);

      rowTotal += cgstAmount + sgstAmount;
    } else {
      const igstRate = Number(product.igst) || 0;

      const igstAmount = taxableValue * (igstRate / 100);

      rowTotal += igstAmount;
    }

    return total + rowTotal;
  }, 0) || 0;
    return (
  <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Orders" breadcrumbItem="Order details" />

        <Button
          type="button"
          color="primary"
          className="mb-3 d-flex align-items-center"
          onClick={() => navigate(-1)}
        >
          <i className="bx bx-arrow-back me-1"></i>
          Back to Orders
        </Button>

        <div className="card" style={{ border: "1px solid #e9ebec" }}>
          <div className="card-body">
            <div className="mb-4">
              <h4 className="fw-bold text-muted">
                Order details - {orderData.order.order_id}
              </h4>
              <p className="text-muted">
                Payment via {orderData.order.payment_mode || "N/A"} -{" "}
                {orderData.order.payment_status || "N/A"}
              </p>
            </div>

            <Row>
              <Col md="4">
                <CardText><strong>User ID:</strong> #{orderData.order.user_id}</CardText>
                <CardText><strong>User Name:</strong> {orderData.order.username}</CardText>
                <CardText><strong>Mobile:</strong> {orderData.order.usermobile_number}</CardText>
                <CardText><strong>Email:</strong> {orderData.order.useremail}</CardText>
                <CardText>
                  <strong>Order Date:</strong>{" "}
                  {formatDateTime(orderData.order.created_at)}
                </CardText>
                <CardText>
                  <strong>Status:</strong>{" "}
                  <OrderdStatus value={orderData.order.order_status} />
                  
                </CardText>
              </Col>

              <Col md="4">
                <CardText><strong>Billing Address</strong></CardText>
                <CardText>{orderData.billingAddress.full_name}</CardText>
                <CardText>{orderData.billingAddress.address}</CardText>
                <CardText>
                  {orderData.billingAddress.city},{" "}
                  {orderData.billingAddress.state}{" "}
                  {orderData.billingAddress.pincode}
                </CardText>
                <CardText>
                    <strong>Notes:</strong>{" "}
                    {orderData.order.notes || "-"}

                    <Button
                      size="sm"
                      color=""
                      className="ms-2 text-success"
                      onClick={() => {
                        setNotes(orderData.order.notes || "");
                        setIsOpen(true);
                      }} >
                      <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                      <UncontrolledTooltip placement="top" target="edittooltip">
                                        Edit Cart
                                      </UncontrolledTooltip>
                    </Button>
                  </CardText>
              </Col>

              <Col md="4">
                <CardText><strong>Shipping Address</strong></CardText>
                <CardText>{orderData.shippingAddress.full_name}</CardText>
                <CardText>{orderData.shippingAddress.address}</CardText>
                <CardText>
                  {orderData.shippingAddress.city},{" "}
                  {orderData.shippingAddress.state}{" "}
                  {orderData.shippingAddress.pincode}
                </CardText>
              </Col>
            </Row>
          </div>
        </div>

        {/* ================= TABS ================= */}

        <Nav tabs className="my-4">
          <NavItem>
            <NavLink
              className={activeTab === "1" ? "active" : ""}
              onClick={() => setActiveTab("1")}
            >
              Order Details
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "2" ? "active" : ""}
              onClick={() => setActiveTab("2")}
            >
              Manage Outward
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "3" ? "active" : ""}
              onClick={() => setActiveTab("3")}
            >
              Manage Invoice
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          {/* ================= TAB 1 ================= */}
          
            <TabPane tabId="1">
    <Card>
        <CardBody>
            <Row>
                <Col lg="12">
                <h5 style={ {marginBottom: "10px"}}>Products in this Order</h5>
                </Col>
            </Row>
            
            <Row>
                <Col lg="12">
                <div className="table-responsive">
                    <table className="table table-bordered align-middle" style={ {tableLayout: "fixed", width: "100%"}}>
                        <thead className="table-light">
                            <tr>
                                <th style={ {width: "3%"}}>#</th>
                                <th style={ {width: "8%"}}>Image</th>
                                <th style={ {width: "30%"}}>Product</th>
                                <th style={ {width: "8%"}} className="text-end">Price</th>
                                <th style={ {width: "7%"}} className="text-center">Qty</th>
                                <th style={ {width: "5%"}} className="text-center">Discount (%)</th>
                                <th style={ { width: "10%"}} className="text-end">Discount Price</th> { isIntraState ? (
                                <>
                                    <th style={ {width: "8%"}} className="text-end">CGST</th>
                                    <th style={ {width: "8%"}} className="text-end">SGST</th>
                                    </>): (
                                    <th style={ {width: "16%"}} className="text-end">IGST</th>) }
                                    <th style={ {width: "13%"}} className="text-end">Sub Total</th>
                            </tr>
                        </thead>
                        <tbody> { orderData.items?.length > 0 ? ( orderData.items.map((product, index)=> { const price=Number(product.price) || 0; const qty=Number(product.quantity) || 0; const discount=Number(product.discount) || 0; const igst=Number(product.igst)
                            || 0; const discountedPrice=price - (price * discount) / 100; const itemSubtotal=discountedPrice * qty; const taxAmount=itemSubtotal * (igst / 100); const rowTotal=itemSubtotal + taxAmount; const taxableValue=(price - (price
                            * discount) / 100) * qty; const cgstRate=Number(product.cgst) || 0; const sgstRate=Number(product.sgst) || 0; const igstRate=Number(product.igst) || 0; const cgstAmount=taxableValue * (cgstRate / 100); const sgstAmount=taxableValue
                            * (sgstRate / 100); const igstAmount=taxableValue * (igstRate / 100); const total=isIntraState ? taxableValue + cgstAmount + sgstAmount: taxableValue + igstAmount; return (
                            <tr key={ product.id || index }>
                                <td> { index + 1 } </td>
                              <td> <img src={ product.fileurl ?  `${imgurl}${product.fileurl}` : "/images/no-image.png"} alt="product-img" title="product-img" className="avatar-md" /> </td>
                                <td>
                                    <h5 className="font-size-14 "> { product?.product_name } </h5>
                                </td>
                                <td className="text-end">₹ {price.toFixed(2)}</td>
                                <td className="text-center"> {qty}</td>
                                <td className="text-center"> {discount}%</td>
                                <td className="text-end">₹ {discountedPrice.toFixed(2)} </td> { isIntraState ? (
                                <>
                                    <td className="text-end"> ₹ {cgstAmount.toFixed(2)} <br /> <small className="text-muted">( {cgstRate} %)</small> </td>
                                    <td className="text-end"> ₹ {sgstAmount.toFixed(2)}<br /> <small className="text-muted">( {sgstRate}%)</small> </td>
                                    </> ): (
                                    <td className="text-end"> ₹ {igstAmount.toFixed(2)} <br /> <small className="text-muted"> {igstRate} %</small> </td>) }
                                    <td className="text-end fw-semibold">₹ { rowTotal.toFixed(2) } </td>
                            </tr>); } )): (
                            <tr>
                                <td colSpan={ 9 } className="text-center"> No Data Found </td>
                            </tr>) } </tbody>
                    </table>
                </div>
                </Col>
            </Row>
            <Row>
                <div className="col-md-8">
                    <CardText> <strong>Delivery Schedule:</strong> </CardText>
                    <CardText> { orderData.order.schedule_type } </CardText>
                </div>
                <div className="col-md-4">
                    <div className="card" style={ { border: "1px solid #e9ebec" } }>
                        <div className="card-body">
                            <h5 className="mb-3 fw-bold">Order Summary</h5>
                            <div className="table-responsive">
                                <Table className="table mb-0">
                                    <tbody>
                                        <tr>
                                            <td>Grand Total :</td>
                                           <td>₹ {subtotal.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>Shipping Charge :</td>
                                            <td>₹ { orderData.order.shipping_charge } </td>
                                        </tr>
                                        <tr>
                                            <td>Estimated Tax: </td>
                                            <td>₹ { orderData.order.shipping_cgst + orderData.order.shipping_sgst + orderData.order.shipping_igst } </td>
                                        </tr>
                                        <tr>
                                            <th>Total :</th>
                                            <th>₹ { orderData.order.total_amount } </th>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
            </Row>
        </CardBody>
    </Card>
</TabPane>
          
          {/* ================= TAB 2 - MANAGE OUTWARD ================= */}
  <TabPane tabId="2">
    <ManageOutward outwardData={outwardItems} orderId={id} />
    
  </TabPane>

  {/* ================= TAB 3 - MANAGE INVOICE ================= */}
  <TabPane tabId="3">
    <ManageInvoice
    invoiceData={invoiceData}

    orderId={id}
    fetchInvoiceDetails={fetchInvoiceDetails}
  />
    
  </TabPane>
        </TabContent>
      </Container>
    </div>
    <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
  <ModalHeader toggle={() => setIsOpen(!isOpen)}>
    Edit Notes
  </ModalHeader>

  <ModalBody>
    <Input
      type="textarea"
      rows="4"
      value={notes}
      onChange={(e) => setNotes(e.target.value)}
      placeholder="Enter notes..."
    />
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" onClick={() => setIsOpen(false)}>
      Cancel
    </Button>

    <Button color="primary" onClick={handleSave}>
      Save
    </Button>
  </ModalFooter>
</Modal>

  </>
);

};
export default withRouter(ViewIndividualOrder);